import React, { useState } from "react";
import { Modal as AntModal, Button, Form, Input, message, Space } from "antd";
import styled from "styled-components";
import { IconCheckLight } from "../../../../assets/icons";
import api from "../../../../api/api";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-header {
    margin-bottom: 24px;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-form {
    .ant-form-item:last-child {
      margin-bottom: 0;
    }
  }

  .ant-space {
    width: 100%;

    .ant-space-item {
      flex: 0.5;
    }

    .ant-btn {
      width: 100%;
      height: 48px;
    }
  }
`;

const LightText = styled.div`
  font-size: 15px;
  font-weight: 400;
  color: #686868;
  line-height: 1.5;
  padding-bottom: 8px;
`;

const InvoiceCodeModal = ({ open, handleClose, successCallback }) => {
  const [loading, setLoading] = useState(false);

  const {t} = useTranslation();

  const onFinish = (values) => {
    let short_code = values.short_code.trim().toUpperCase();
    if (!loading) {
      setLoading(true);
      api
        .updateInvoiceShortCode({ short_code })
        .then(() => {
          setLoading(false);
          message.success("Saved successfully!");
          successCallback(short_code);
          handleClose();
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  return (
    <Modal
      centered
      open={open}
      title={t('create_short')}
      onCancel={onCancel}
      footer={false}
    >
      <LightText>
       {t('invoice_text')}
      </LightText>
      <Form onFinish={onFinish}>
        <Form.Item
          name={"short_code"}
          rules={[
            { required: true, message: "" },
            {
              pattern: /^[A-Za-z]+$/,
              message: t('short_code_must'),
            },
          ]}
        >
          <Input placeholder={t('enter_short_code')} showCount maxLength={5} />
        </Form.Item>
        <Form.Item>
          <Space size={"middle"}>
            <Button type="default" onClick={onCancel}>
              {t('cancel')}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              icon={<IconCheckLight />}
              loading={loading}
            >
              {t('save')}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default InvoiceCodeModal;
